export const referrals = {
  menu: {
    label: "Indique e ganhe",
    badge: "Ganhe",
  },
  welcomeCard: {
    title: "Seu plano pode sair de graça",
    desc: "Convide outros anfitriões e ganhe uma parte de tudo o que eles pagarem, para sempre.",
  },
  page: {
    loading: "Carregando suas indicações…",
    previewNotice: "Pré-visualização com dados de exemplo. Suas indicações reais aparecerão aqui quando o programa estiver ativo.",
  },
  hero: {
    title: "Convide outros anfitriões e use a WACheckin de graça",
    subtitle: "Para cada anfitrião que assinar com o seu link, você ganha {percent}% de tudo o que ele pagar, todos os meses e para sempre. Seu colega começa com {friendPercent}% de desconto.",
    personal: "Seu plano custa {price} por mês. Com {count} indicados como você, você não paga mais nada.",
    personalGeneric: "Com {count} anfitriões como você pagando, seu plano sai de graça.",
  },
  rewards: {
    youGet: "Você ganha",
    youGetBig: "{percent}% de cada pagamento",
    youGetSmall: "de cada anfitrião que você convidar, todos os meses e para sempre",
    friendGets: "Seu colega ganha",
    friendGetsBig: "{percent}% de desconto",
    friendGetsSmall: "nos primeiros {months} meses",
    example: "Se você convidar um anfitrião com {units} apartamentos, ganha cerca de {amount} por ano enquanto ele continuar com a gente.",
  },
  welcomeOffer: {
    title: "Seu presente de boas-vindas",
    text: "{name} convidou você para a WACheckin: você tem {percent}% de desconto nos primeiros {months} meses. É aplicado quando você assinar seu plano.",
  },
  share: {
    title: "Seu link de convite",
    codeLabel: "Seu código",
    copy: "Copiar link",
    copied: "Copiado",
    whatsapp: "WhatsApp",
    invite: "Enviar por e-mail",
    more: "Mais",
    message: "Te indico a WACheckin: uso para o check-in online, as mensagens aos hóspedes e para conectar Booking e Airbnb, e ela me economiza muito tempo. Com o meu link você tem {percent}% de desconto nos primeiros {months} meses: {link}",
    emailSubject: "Ganhe {percent}% de desconto na WACheckin com o meu link",
  },
  invite: {
    title: "Convide por e-mail",
    subtitle: "Vamos enviar ao seu colega um convite pessoal com o seu link e o desconto de {percent}%.",
    emailLabel: "E-mail do seu colega",
    emailPlaceholder: "nome@empresa.com",
    languageLabel: "Idioma do e-mail",
    cancel: "Cancelar",
    send: "Enviar convite",
    sending: "Enviando…",
    successTitle: "Convite enviado!",
    successDesc: "Enviamos o seu convite para {email}.",
    another: "Convidar outro colega",
    close: "Fechar",
    errors: {
      invalidEmail: "Digite um e-mail válido.",
      selfInvite: "Você não pode enviar o convite para o seu próprio e-mail.",
      alreadyInvited: "Você já convidou este e-mail recentemente. Poderá tentar de novo em alguns dias.",
      dailyLimit: "Você atingiu o limite de convites de hoje. Tente novamente amanhã.",
      tooFast: "Muitas tentativas seguidas. Aguarde um minuto e tente novamente.",
      generic: "Não foi possível enviar o convite. Tente novamente.",
    },
  },
  message: {
    title: "Mensagem pronta para compartilhar",
    hint: "Cole nos seus grupos de anfitriões, fóruns ou redes sociais. Funciona melhor com uma frase sua.",
    copy: "Copiar mensagem",
  },
  how: {
    title: "Como funciona",
    stepLabel: "Passo {n}",
    step1Title: "Compartilhe seu link",
    step1Desc: "Pelo WhatsApp, e-mail ou nos seus grupos de anfitriões.",
    step2Title: "Seu colega assina com desconto",
    step2Desc: "Ele se cadastra com seu link e começa com {percent}% de desconto.",
    step3Title: "Você ganha todo mês",
    step3Desc: "{percent}% de cada pagamento vira crédito para você, para sempre. O primeiro conta após {days} dias.",
  },
  results: {
    title: "Seus resultados",
    celebrate: "Você já ganhou {amount}.",
    coverage: "Seus indicados já cobrem {percent}% do seu plano",
    coverageFree: "Seu plano já sai de graça",
    coverageHint: "Seu plano custa {price} por mês e seus indicados te rendem {earning} por mês.",
  },
  stats: {
    invited: "Convidados",
    subscribed: "Pagando",
    monthlyEarning: "Ganhos por mês",
    creditAvailable: "Crédito disponível",
    creditEarned: "{amount} ganhos no total",
    creditHint: "Descontado automaticamente da sua próxima fatura",
  },
  list: {
    title: "Suas indicações",
    colName: "Conta",
    colDate: "Cadastro",
    colStatus: "Status",
    colReward: "O que você ganha",
    empty: "Você ainda não convidou ninguém. O primeiro anfitrião que assinar com o seu link já começa a te render crédito todo mês.",
  },
  status: {
    registered: "Cadastrado",
    subscribed: "Pagando",
    rewarded: "Ganhando",
    canceled: "Cancelou",
    rejected: "Não elegível",
  },
  reward: {
    waiting: "Aguardando o primeiro pagamento",
    startsOn: "Você começa a ganhar em {date}",
    earning: "{monthly} por mês, {earned} no total",
    earningNoPlan: "{earned} no total",
    canceled: "{earned} ganhos",
  },
  reasons: {
    duplicate: "Conta duplicada",
    selfReferral: "Autoindicação",
  },
  faq: {
    title: "Perguntas frequentes",
    howMuchQ: "Quanto eu ganho?",
    howMuchA: "{percent}% de tudo o que cada anfitrião que você convidar pagar (sem impostos), todos os meses e para sempre, sem limite de indicações. Se ele pagar {price} por mês, você ganha cerca de {amount} por mês.",
    whenQ: "Quando eu recebo?",
    whenA: "Cada vez que o seu indicado paga, o valor é somado automaticamente ao seu crédito. O primeiro pagamento conta após {days} dias, caso ele cancele logo depois de assinar.",
    whereQ: "Onde o crédito é usado?",
    whereA: "Ele é descontado automaticamente das suas próximas faturas da WACheckin. Se você ainda não assinou, é aplicado na sua primeira fatura.",
    limitQ: "Existe algum limite?",
    limitA: "Não há limite de indicações nem de tempo. O único: o crédito que você acumulou sem usar chega no máximo a {months} meses do seu plano. Enquanto estiver nesse teto, seu plano continua saindo de graça; o que passar disso não é acumulado.",
    stopQ: "Quando deixo de ganhar?",
    stopA: "Se o seu indicado cancelar, você deixa de ganhar por ele. Se você cancelar, deixa de acumular crédito.",
    whoQ: "Quem posso convidar?",
    whoA: "Qualquer anfitrião ou hotel que ainda não use a WACheckin. Autoindicações e contas duplicadas não são elegíveis.",
  },
};
